export const submitting = state => state.changePolicyOther.submitting
export const successful = state => state.changePolicyOther.successful
